import { EventEmitter } from '@pixi/utils';
import type { Filter as PixiFilter } from 'pixi.js';
import { TypedParentMixin } from '../parentMixin';
import { TypedSerializableMixin } from '../serializableMixin';
import { TypedUpdateFlowMixin } from '../updateFlowMixin';

export abstract class Filter extends TypedUpdateFlowMixin(
    TypedParentMixin(TypedSerializableMixin(EventEmitter)),
) {
    abstract override _classType: string;
    /** @internal */
    abstract pixiFilter: PixiFilter;

    override get readonlyProperties() {
        return ['classType', 'name'];
    }

    abstract isNeutral(): boolean;

    get resolution(): number | null {
        return this.pixiFilter.resolution;
    }

    set resolution(value: number | null) {
        this.pixiFilter.resolution = value;
    }

    destroy() {
        this.pixiFilter.destroy();
    }
}
